import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
//#region src/EditArea/index.tsx
const EditArea = forwardRef(({ className, onBlur, onChange, defaultValue = "", disabled = false, maxRows, ...props }, forwardedRef) => {
	const internalRef = useRef(null);
	const initialValue = useRef(defaultValue);
	useImperativeHandle(forwardedRef, () => internalRef.current, []);
	const handleInternalBlur = (event) => {
		if (onBlur) {
			onBlur(event.target.value, initialValue.current);
			initialValue.current = event.target.value;
		}
	};
	const handleKeyDown = (event) => {
		const textarea = internalRef.current;
		if (!textarea) return;
		const lines = textarea.value.split("\n");
		const lineHeight = Number.parseInt(getComputedStyle(textarea).lineHeight, 10);
		const maxHeight = maxRows ? lineHeight * maxRows + lineHeight : lineHeight;
		if (maxRows && lines.length >= maxRows && event.key === "Enter") event.preventDefault();
		if (maxRows && textarea.scrollHeight > maxHeight && ![
			"Backspace",
			"Delete",
			"Enter",
			"ArrowUp",
			"ArrowDown",
			"ArrowLeft",
			"ArrowRight"
		].includes(event.key) && !event.ctrlKey) event.preventDefault();
	};
	const adjustTextareaHeight = useCallback(() => {
		const textarea = internalRef.current;
		if (textarea) {
			textarea.style.height = "auto";
			textarea.style.height = `${textarea.scrollHeight}px`;
		}
	}, []);
	const handleChange = (event) => {
		if (disabled) return;
		onChange?.(event.target.value);
		adjustTextareaHeight();
	};
	useEffect(() => {
		adjustTextareaHeight();
	}, [adjustTextareaHeight, defaultValue]);
	useEffect(() => {
		const textarea = internalRef.current;
		if (textarea) {
			textarea.value = defaultValue;
			adjustTextareaHeight();
		}
	}, [defaultValue, adjustTextareaHeight]);
	return /* @__PURE__ */ jsx("textarea", {
		ref: internalRef,
		disabled,
		onKeyDown: handleKeyDown,
		className: cn("focus:border-brand-40 h-full w-full resize-none overflow-hidden rounded-md border border-transparent bg-transparent px-2 py-1 leading-none outline-0 transition duration-75", className),
		rows: 1,
		onBlur: handleInternalBlur,
		onChange: handleChange,
		...props
	});
});
EditArea.displayName = "EditArea";
//#endregion
export { EditArea };

//# sourceMappingURL=index.js.map